export type BrandKey = 'buzzzg' | 'cloudline';

export interface BrandContext {
  key: BrandKey;
  name: string;
  portalName: string;
  logoPath: string;
  logoAlt: string;
  faviconPath: string;
  homePath: string;
  supportEmail: string;
  supportPhone: string;
  supplierKeywords?: string[];
}

export const BUZZZG_BRAND: BrandContext = {
  key: 'buzzzg',
  name: 'BuzzzG',
  portalName: 'Buzzzg Web',
  logoPath: '/assets/BuzzZg_Logo.png',
  logoAlt: 'BuzzZg Logo',
  faviconPath: '/assets/BuzzZg_Logo.png',
  homePath: '/',
  supportEmail: 'admin@buzzzg.com',
  supportPhone: '(929) 291 1212',
};

export const CLOUDLINE_BRAND: BrandContext = {
  key: 'cloudline',
  name: 'Cloudline Wholesale',
  portalName: 'Cloudline Wholesale',
  logoPath: '/assets/cloudline-wholesale-logo.png',
  logoAlt: 'Cloudline Wholesale Logo',
  faviconPath: '/assets/cloudline-wholesale-logo.png',
  homePath: '/',
  supportEmail: 'admin@cloudlinewholesale.com',
  supportPhone: '(508) 369-5758',
  supplierKeywords: ['cloudline'],
};

export function isCloudlineHost(hostname: string | null | undefined): boolean {
  const host = String(hostname ?? '').trim().toLowerCase();
  return [
    'cloudlinewholesale.com',
    'www.cloudlinewholesale.com',
    'dev.cloudlinewholesale.com',
    'cloudline-dev.buzzzg.com',
    'cloudline.localhost',
  ].includes(host);
}

function isLocalOrDevHost(hostname: string | null | undefined): boolean {
  const host = String(hostname ?? '').trim().toLowerCase();
  return (
    host === 'localhost' ||
    host === '127.0.0.1' ||
    host === 'cloudline.localhost' ||
    host.endsWith('.localhost') ||
    host.endsWith('.dev.buzzzg.com')
  );
}

function getBrandQueryOverride(): BrandKey | null {
  if (typeof window === 'undefined') {
    return null;
  }

  const brand = new URLSearchParams(window.location.search).get('brand')?.trim().toLowerCase();
  return brand === 'cloudline' || brand === 'buzzzg' ? brand : null;
}

export function getBrandContext(hostname?: string | null): BrandContext {
  const resolvedHost = hostname ?? (typeof window !== 'undefined' ? window.location.hostname : '');
  const queryOverride = isLocalOrDevHost(resolvedHost) ? getBrandQueryOverride() : null;

  if (queryOverride === 'cloudline') {
    return CLOUDLINE_BRAND;
  }

  if (queryOverride === 'buzzzg') {
    return BUZZZG_BRAND;
  }

  return isCloudlineHost(resolvedHost) ? CLOUDLINE_BRAND : BUZZZG_BRAND;
}
